import { render, staticRenderFns } from "./OrganizationPrivacyPolicy.vue?vue&type=template&id=48fc2461"
import script from "./OrganizationPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./OrganizationPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports